/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';

export default function EmptyPage({ Content, tag }) {
    return (
        <div className="pt-9 sm:px-[128px] px-4">
            {/* <p className="text-[#555259] font-normal text-xl">User Management</p> */}
            <div className="flex justify-center items-center flex-col h-customh2 px-2">
                <img src="/images/Group8022.svg" alt="icon" className="mx-auto" />
                {Content || (
                    <p className="lg:text-xs16 sm:text-xl text-base font-normal text-[#15090E] sm:pt-[26px] pt-[18px]">
                        It seems like there are
                        <span className="text-[#ED1C24]">{tag}</span>
                        {' '}
                        listed yet!
                    </p>
                )}
            </div>
        </div>
    );
}
